module.exports = __webpack_public_path__ + "img/logo-202605.3f81e95c.png";